<template>
  <div
    class="color-button"
    :class="{
      disabled: disabled,
      'round-color-button': round,
      [color + '-button']: true
    }"
    @click="click"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    round: Boolean,
    color: String
  },
  methods: {
    click () {
      if (this.disabled) return
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.color-button { background: none; border: none; border-radius: 3px; color: #263238; cursor: pointer; display: inline-block; height: 30px; line-height: 26px; padding: 0 15px; position: relative; text-align: center; }
.color-button:before { background: rgba(255, 255, 255, 0); border-radius: 15px; bottom: 0; content: ''; left: 0; position: absolute; right: 0; top: 0; -webkit-transition: background-color .3s; -moz-transition: background-color .3s; -o-transition: background-color .3s; transition: background-color .3s; }
.color-button:hover:before { background: rgba(255, 255, 255, .1); }
.color-button.disabled { background: gray; cursor: default; }
.color-button.disabled:before { background: none; }
.round-color-button { border-radius: 15px; }
.yellow-button {
  background: #8CE95D;
  color: #231e4a;
  /* font-weight: bolder; */
}
</style>



// WEBPACK FOOTER //
// src/components/buttons/ColorButton.vue